import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { CHILDREN_COMPONENT, INHERITED_NAME } from "./core/index.mjs";
import getOriginChildren from "./getOriginChildren.mjs";
import isNode from "./isNode.mjs";
function addonTextChildren(Children, Text, Addon) {
  var isTextWrapIfEmptyChildren = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var children = getOriginChildren(Children);
  if (typeof children === 'function') {
    return /*#__PURE__*/React.createElement(Children, null);
  }
  if (!isTextWrapIfEmptyChildren && !isNode(children)) {
    return null;
  }
  return React.Children.toArray(children).some(function (element) {
    if (! /*#__PURE__*/React.isValidElement(element)) return false;
    if (element.type === React.Fragment) return true;
    if (element.type[CHILDREN_COMPONENT]) {
      var wrapChildren = addonTextChildren(element.type, Text, Addon);
      if (wrapChildren.type[CHILDREN_COMPONENT]) {
        return true;
      } else {
        element = wrapChildren;
      }
    }
    // @ts-ignore
    var inheritedNames = element.type[INHERITED_NAME] || [element.type.displayName];
    var addonNames = Array.isArray(Addon) ? Addon.map(function (Component) {
      return Component.displayName;
    }) : [Addon.displayName];
    return [Text.displayName].concat(_toConsumableArray(addonNames)).find(function (name) {
      return inheritedNames.includes(name);
    });
  }) ? /*#__PURE__*/React.createElement(Children, null) : /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Children, null));
}
export default addonTextChildren;
//# sourceMappingURL=addonTextChildren.mjs.map